<script>
import feather from 'feather-icons';
import FooterCopyright from './FooterCopyright.vue';
export default {
	components: { FooterCopyright },
	data() {
		return {
			socials: [
				{
					id: 2,
					name: 'Instagram',
					icon: 'instagram',
					url: 'https://www.instagram.com/RyanTime99/',
				},
				{
					id: 3,
					name: 'Youtube',
					icon: 'youtube',
					url: 'https://www.youtube.com/channel/UCbF1Y6jY8W817wIz75mpd4g?sub_confirmation=1 ',
				},
				{
					id: 4,
					name: 'Twitch',
					icon: 'twitch',
					url: 'https://www.twitch.tv/ryantime99',
				},
				{
					id: 5,
					name: 'LiChess',
					icon: 'command',
					url: 'https://lichess.org/@/RyanTime',
				},
				{
					id: 6,
					name: 'Chess',
					icon: 'clipboard',
					url: 'https://www.chess.com/member/ryantime',
				},

			],
			info: { email: 'chesswithryan@gmail.com', phone: '425-623-7900' }
		};
	},
	mounted() {
		feather.replace();
	},
	updated() {
		feather.replace();
	},
};
</script>

<template>
	<div class="container mx-auto bg-white" v-if="0">
		<div class="pt-8 pb-8 mt-4 border-t-2 border-primary-light dark:border-secondary-dark">
			<!-- Footer social links -->
			<div class="flex flex-col justify-center items-center mb-12 sm:mb-20">
				<p
					class="font-general-semibold text-3xl sm:text-4xl font-semibold text-primary-dark dark:text-primary-light mb-5 text-white">
					Follow me
				</p>
				<ul class="flex gap-4 sm:gap-8">
					<a v-for="social in socials" :key="social.id" :href="social.url" target="__blank"
						class="text-gray-400 hover:text-pink-500 dark:hover:text-pink-400 cursor-pointer rounded-lg bg-gray-50 dark:bg-ternary-dark hover:bg-gray-100 shadow-sm p-4 duration-500">
						<i v-if="id < 5" :data-feather="social.icon" class="w-5 sm:w-8 h-5 sm:h-8"></i>
						<img class="w-auto" src="@/assets/images/icons/lichess.svg" />
						<!-- <img class="w-auto" src="@/assets/images/icons/lichess.svg" /> -->
					</a>
				</ul>
			</div>

			<!-- Footer copyright -->
			<FooterCopyright />
		</div>
	</div>
	<!-- Footer section with social media icons and newsletter sign-up -->
	<footer
		class="flex mx-auto flex-col items-center bg-zinc-50 text-center text-surface dark:bg-neutral-700 dark:text-white w-full">
		<div class="xl:container pt-6 bg-gray-800 text-white w-full">
			<!-- Social media icons container -->

			<div class="mb-6 flex justify-center space-x-2">
				<ul class="flex gap-2 sm:gap-8">
					<a v-for="social in socials" :key="social.id" :href="social.url" target="__blank"
						class="w-16 flex justify-center items-center text-gray-800 hover:text-pink-500 dark:hover:text-pink-400 cursor-pointer rounded-full bg-gray-50 dark:bg-ternary-dark hover:bg-gray-100 shadow-sm p-4 duration-500">
						<!-- <i :data-feather="social.icon" class="w-5 sm:w-8 h-5 sm:h-8"></i> -->
						<i v-if="social.id < 5" :data-feather="social.icon" class="w-5 sm:w-8 h-5 sm:h-8"></i>
						<svg v-if="social.id == 5" fill="#000000" width="36" height="36" viewBox="0 0 24 24" role="img"
							xmlns="http://www.w3.org/2000/svg">
							<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
							<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
							<g id="SVGRepo_iconCarrier">
								<path
									d="M10.457 6.161a.237.237 0 0 0-.296.165c-.8 2.785 2.819 5.579 5.214 7.428.653.504 1.216.939 1.591 1.292 1.745 1.642 2.564 2.851 2.733 3.178a.24.24 0 0 0 .275.122c.047-.013 4.726-1.3 3.934-4.574a.257.257 0 0 0-.023-.06L18.204 3.407 18.93.295a.24.24 0 0 0-.262-.293c-1.7.201-3.115.435-4.5 1.425-4.844-.323-8.718.9-11.213 3.539C.334 7.737-.246 11.515.085 14.128c.763 5.655 5.191 8.631 9.081 9.532.993.229 1.974.34 2.923.34 3.344 0 6.297-1.381 7.946-3.85a.24.24 0 0 0-.372-.3c-3.411 3.527-9.002 4.134-13.296 1.444-4.485-2.81-6.202-8.41-3.91-12.749C4.741 4.221 8.801 2.362 13.888 3.31c.056.01.115 0 .165-.029l.335-.197c.926-.546 1.961-1.157 2.873-1.279l-.694 1.993a.243.243 0 0 0 .02.202l6.082 10.192c-.193 2.028-1.706 2.506-2.226 2.611-.287-.645-.814-1.364-2.306-2.803-.422-.407-1.21-.941-2.124-1.56-2.364-1.601-5.937-4.02-5.391-5.984a.239.239 0 0 0-.165-.295z">
								</path>
							</g>
						</svg>
						<svg v-if="social.id == 6" fill="#000000" height="36" width="32" version="1.1" id="Layer_1"
							xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
							viewBox="0 0 512 512" xml:space="preserve">
							<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
							<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
							<g id="SVGRepo_iconCarrier">
								<g>
									<g>
										<g>
											<path
												d="M266.487,35.439c-4.557-1.178-9.208,1.604-10.359,6.17c-1.161,4.574,1.604,9.216,6.178,10.368 c9.131,2.313,16.23,9.412,18.517,18.526c0.973,3.874,4.454,6.451,8.269,6.451c0.691,0,1.391-0.085,2.091-0.256 c4.574-1.152,7.339-5.786,6.195-10.359C293.538,51.132,281.711,39.287,266.487,35.439z">
											</path>
											<path
												d="M349.867,426.667h-1.075c5.896-7.356,9.609-16.358,9.609-25.6c0-16.657-8.235-33.604-17.775-53.24 c-11.665-24.013-24.892-51.243-24.892-83.294c0-43.17,4.574-68.113,6.844-77.85c10.778-3.012,18.756-12.817,18.756-24.55 c0-14.114-11.486-25.6-25.6-25.6h-11.563C321.604,122.445,332.8,100.915,332.8,76.8C332.8,34.458,298.351,0,256,0 s-76.8,34.458-76.8,76.8c0,24.115,11.196,45.645,28.629,59.733h-11.563c-14.114,0-25.6,11.486-25.6,25.6s11.486,25.6,25.6,25.6 H281.6c4.719,0,8.533-3.823,8.533-8.533s-3.814-8.533-8.533-8.533h-85.333c-4.71,0-8.533-3.831-8.533-8.533 c0-4.702,3.823-8.533,8.533-8.533h119.467c4.71,0,8.533,3.831,8.533,8.533c0,4.702-3.823,8.533-8.533,8.533 c-0.119,0-0.205,0.06-0.324,0.068c-0.64,0.026-1.229,0.205-1.835,0.367c-0.478,0.128-0.956,0.188-1.391,0.393 c-0.521,0.239-0.93,0.597-1.391,0.939c-0.435,0.316-0.887,0.572-1.246,0.956c-0.341,0.358-0.555,0.811-0.828,1.237 c-0.341,0.512-0.691,1.007-0.922,1.596c-0.043,0.102-0.12,0.171-0.154,0.282c-0.367,1.101-8.977,27.605-8.977,88.03 c0,35.985,14.754,66.347,26.607,90.752c8.619,17.732,16.06,33.05,16.06,45.781c0,12.442-13.158,25.6-25.6,25.6H230.4 c-4.719,0-8.533,3.823-8.533,8.533s3.814,8.533,8.533,8.533h119.467c12.442,0,25.6,13.158,25.6,25.6v25.6H136.533v-25.6 c0-12.442,13.158-25.6,25.6-25.6h34.133c4.719,0,8.533-3.823,8.533-8.533s-3.814-8.533-8.533-8.533 c-12.442,0-25.6-13.158-25.6-25.6c0-12.732,7.441-28.049,16.06-45.781c11.853-24.405,26.607-54.767,26.607-90.752 c0-11.221-1.408-28.834-4.173-52.343c-0.555-4.685-4.787-8.081-9.481-7.475c-4.676,0.555-8.021,4.796-7.475,9.481 c2.662,22.519,4.062,39.927,4.062,50.338c0,32.051-13.227,59.281-24.892,83.294c-9.54,19.635-17.775,36.582-17.775,53.24 c0,9.233,3.678,18.253,9.566,25.6h-1.033c-21.931,0-42.667,20.736-42.667,42.667v34.133c0,4.71,3.814,8.533,8.533,8.533h256 c4.719,0,8.533-3.823,8.533-8.533v-34.133C392.533,447.403,371.797,426.667,349.867,426.667z M256,136.533 c-32.93,0-59.733-26.795-59.733-59.733S223.07,17.067,256,17.067s59.733,26.795,59.733,59.733S288.93,136.533,256,136.533z">
											</path>
										</g>
									</g>
								</g>
							</g>
						</svg>

					</a>
				</ul>
			</div>

			<!-- Newsletter sign-up form -->
			<!-- <div>
				<form action="">
					<div class="grid items-center justify-center gap-4 grid-cols-1 md:grid-cols-2">
						<div class="md:mb-6 md:ms-auto">
							<p>
								<strong class="text-white"><a :href="'tel:' + info.phone">{{ info.phone }}</a></strong>
							</p>
						</div>

						<div class="md:mb-6 md:ms-auto">
							<p>
								<strong class="text-white"><a :href="'mailto:' + info.email">{{ info.email
										}}</a></strong>
							</p>
						</div>
					</div>
				</form>
			</div> -->
			<!-- <div class="flex justify-center items-center">
			</div> -->
			<div class="sm:flex justify-center items-center pb-4 pt-2">
				<p class="text-center text-white rounded-xl mr-4">
					Chess.com
				</p>
				<a href="http://play.google.com/store/apps/details?id=com.chess" class="mr-4" target="_blank">
					<img src="@/assets/images/new/google-play.png" alt="" class="rounded-lg h-16 mx-auto" />
				</a>
				<a href="https://apps.apple.com/us/app/chess-play-learn/id329218549?mt=8&uo=4" class=""
					target="itunes_store">
					<img src="@/assets/images/new/apple-store.png" alt="" class="rounded-lg h-16 mx-auto" />
				</a>
			</div>

			<!-- Copyright information -->
			<!-- <div class="mb-6">
				<p class="text-white">
					Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt
					distinctio earum repellat quaerat voluptatibus placeat nam,
					commodi optio pariatur est quia magnam eum harum corrupti dicta,
					aliquam sequi voluptate quas.
				</p>
			</div> -->

			<!-- Links section -->
			<div class="grid md:grid-cols-2 lg:grid-cols-4">
				<div class="mb-6">
					<p class="mb-2.5 text-xl font-bold uppercase text-white">Site Links</p>

					<ul class="mb-0 list-none">
						<li>
							<router-link @click="hideMenu()" to="/" class="text-white">Home</router-link>
						</li>
						<li>
							<router-link to="/testimonials" class="text-white">Testimonials</router-link>
						</li>
						<li>
							<router-link to="/book-class" class="text-white">Pricing</router-link>
						</li>
						<li>
							<router-link to="/terms" class="text-white">Terms</router-link>
						</li>
					</ul>
				</div>

				<div class="mb-6">
					<p class="mb-2.5 text-xl font-bold uppercase text-white">Media Links</p>

					<ul class="mb-0 list-none">
						<li>
							<router-link to="/gallery" class="text-white">Gallery</router-link>
						</li>
						<li>
							<router-link to="/lesson-plan" class="text-white">Lesson plan</router-link>
						</li>
					</ul>
				</div>

				<div class="mb-6">
					<p class="mb-2.5 text-xl font-bold uppercase text-white">Booking links</p>

					<ul class="mb-0 list-none">
						<li>
							<router-link to="/book-class" class="text-white">Scheduling</router-link>
						</li>
					</ul>
				</div>

				<div class="mb-6">
					<p class="mb-2.5 text-xl font-bold uppercase text-white">External Links</p>

					<ul class="mb-0 list-none">
						<li>
							<a href="https://chess.com" class="text-white" target="_blank">CHESS.COM</a>
						</li>
						<li>
							<a href="https://chesskid.com" class="text-white" target="_blank">CHESSKID.COM</a>
						</li>
						<li>
							<router-link to="/attribution" class="text-white">Attribution</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<!-- Copyright section -->
		<!-- <div class="w-full bg-black/5 p-4 text-center">
			© 2023 Copyright:
			<a class="font-semibold" href="https://tw-elements.com/">TW Elements</a>
		</div> -->
		<FooterCopyright />

	</footer>
</template>

<style scoped></style>
